import { render, staticRenderFns } from "./invite-setting.vue?vue&type=template&id=501c0ef0&scoped=true";
import script from "./invite-setting.vue?vue&type=script&lang=js";
export * from "./invite-setting.vue?vue&type=script&lang=js";
import style0 from "./invite-setting.vue?vue&type=style&index=0&id=501c0ef0&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "501c0ef0", null);
export default component.exports;